module.exports = __webpack_public_path__ + "img/selected7-min.c2fdb65f.png";